import { BaseModel } from '@/modules/core/app/models/abstracts/BaseModel';

export class ExtractedRecordUnfilledField extends BaseModel {
  field?: string;
  reasonCode?: string;

  constructor(model: Partial<ExtractedRecordUnfilledField> = {}) {
    super(model);

    this.field = model.field;
    this.reasonCode = model.reasonCode;
  }
}
